export default [
  {
    path: "/teacher-list",
    component: (resolve) => require(["@/vuepage/teacher-manage/normal/list.vue"], resolve),
    meta: [
      {
        name: "老师管理",
      },
      {
        name: "授课老师",
        activeRoute: "/teacher-list",
      },
    ],
  },
  {
    path: "/teacher-add",
    component: (resolve) => require(["@/vuepage/teacher-manage/normal/add.vue"], resolve),
    meta: [
      {
        name: "老师管理",
      },
      {
        name: "新增老师",
        activeRoute: "/teacher-list",
      },
    ],
  },
  {
    path: "/teacher-schedule",
    component: (resolve) => require(["@/vuepage/teacher-manage/normal/schedule.vue"], resolve),
    meta: [
      {
        name: "老师管理",
      },
      {
        name: "日程安排",
        activeRoute: "/teacher-list",
      },
    ],
  },
  {
    path: "/teacher-responsible",
    component: (resolve) => require(["@/vuepage/teacher-manage/responsible/list.vue"], resolve),
    meta: [
      {
        name: "老师管理",
      },
      {
        name: "责任老师",
        activeRoute: "/teacher-responsible",
      },
    ],
  },
  {
    path: "/teacher-responsible-add",
    component: (resolve) => require(["@/vuepage/teacher-manage/responsible/add.vue"], resolve),
    meta: [
      {
        name: "老师管理",
      },
      {
        name: "新增责任老师",
        activeRoute: "/teacher-responsible",
      },
    ],
  },
];
